var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.362,
    height: 11.763,
    viewBox: "0 0 14.362 11.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-check",
    "data-name": "Icon feather-user-check",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4960",
    "data-name": "Path 4960",
    d: "M10.469,26.088v-1.2A2.392,2.392,0,0,0,8.077,22.5H3.892A2.392,2.392,0,0,0,1.5,24.892v1.2",
    transform: "translate(0 -10.825)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4961",
    "data-name": "Path 4961",
    d: "M11.533,6.892A2.392,2.392,0,1,1,9.142,4.5a2.392,2.392,0,0,1,2.392,2.392Z",
    transform: "translate(-3.157)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    d: "M25.5,14.7l1.2,1.2L29.088,13.5",
    transform: "translate(-14.433 -5.412)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.9dc3dd343de1b5b7d5e29afd8db6f055.svg";
export { ForwardRef as ReactComponent };